import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
  external?: boolean;
};
export function CtaButton({
  children,
  size = 'lg',
  className = '',
  href = '#comprar',
  external = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg tracking-tight' : 'px-6 py-4 text-sm sm:text-base';
  const handleClick = () => {
    if (external) {
      trackPixelEvent('InitiateCheckout', {
        value: 17,
        currency: 'USD'
      });
    } else {
      trackPixelEvent('Lead', {
        content_name: 'CTA a la oferta'
      });
    }
  };
  return <a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-rose-500 font-semibold text-white shadow-[0_16px_36px_-18px_rgba(185,102,121,0.85)] outline-none transition-[transform,background-color,box-shadow] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-0.5 hover:bg-rose-600 focus-visible:ring-2 focus-visible:ring-rose-300 focus-visible:ring-offset-2 focus-visible:ring-offset-cream-50 active:translate-y-0 ${sizing} ${className}`} data-id="element-39" data-mp="vclime9oyzp3">
      <span className="text-center" data-id="element-40" data-mp="3jy8h5n6zvsba">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" data-id="element-41" data-mp="3owtmg113t26l" />
    </a>;
}